import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';
import { BUTTON_TYPES } from '../../components/ShowContactByDataPoint/constants';
import { SEARCH_STATUS } from '../../utils/constants';
import { SEARCH_TABS } from '../../views/SearchTab/constants';
import Company from '../Company';
import Contact from '../Contact';
import PreviousJobDataModel from '../Contact/PreviousJobData/PreviousJobDataModel';
import Actions from './Actions';
import Views from './Views';
import { PROSPECTING_TABS } from './constants';
const LocationFilterModel = types.model({
    code: types.string,
    name: types.string,
});
const SearchQueryMetadataModel = types.model({
    indicatorNotFound: types.boolean,
    indicatorSelector: types.maybeNull(types.string),
    parserType: types.string,
    isUnifiedParser: types.boolean,
    isUnifiedParserEnabled: types.boolean,
    parserCategory: types.string,
    contactsOnPage: types.number,
    contactsParsed: types.number,
    platform: types.string,
});
const SearchQueryModel = types.model('SearchData', {
    contacts: types.array(types.frozen()),
    source_platform: types.string,
    url: types.string,
    product: types.string,
    webPluginVersion: types.string,
    platformView: types.string,
    metadata: SearchQueryMetadataModel,
});
const ModelProps = {
    companyName: types.optional(types.string, ''),
    companyUrl: types.optional(types.string, ''),
    companyDomain: types.optional(types.string, ''),
    companyLogoUrl: types.optional(types.string, ''),
    isRecent: types.optional(types.boolean, false),
    employee: types.reference(Contact),
    employeeFreeText: types.optional(types.string, ''),
    rank: types.optional(types.integer, 0),
    companySearchId: types.optional(types.string, ''),
    companyLid: types.optional(types.maybeNull(types.integer), null),
    companyLids: types.optional(types.array(types.optional(types.integer, 0)), []),
    // Filters - Prospecting Lite
    seniorityFilters: types.array(types.optional(types.string, '')),
    departmentsFilters: types.array(types.optional(types.string, '')),
    emailFilters: types.array(types.optional(types.string, '')),
    locationFilters: types.array(LocationFilterModel),
    // Filters - Bulk Enrich
    bulkFilters: types.optional(types.array(types.optional(types.string, '')), ['all']),
    address: types.optional(types.string, ''),
    fullName: types.optional(types.string, ''),
    html: types.optional(types.string, ''),
    htmlLength: types.optional(types.integer, 0),
    date: types.optional(types.string, ''),
    messageId: types.optional(types.string, ''),
    threadViewId: types.optional(types.string, ''),
    url: types.optional(types.string, ''),
    currentContactId: types.optional(types.string, ''),
    currentCompanyId: types.optional(types.string, ''),
    prospectContacts: types.map(Contact),
    prospectCompanies: types.map(types.reference(Company)),
    requestId: types.optional(types.string, ''),
    maskedId: types.optional(types.string, ''),
    canShowContact: types.maybeNull(types.optional(types.boolean, false)),
    sessionId: types.optional(types.string, uuid()),
    moreResults: types.optional(types.boolean, false),
    searchStatus: types.optional(types.enumeration('SEARCH_STATUS', Object.values(SEARCH_STATUS)), SEARCH_STATUS.IDLE),
    firstSearch: types.optional(types.boolean, true),
    keyPeople: types.array(Contact),
    noSearchData: types.optional(types.boolean, false),
    showEmployeesCounterBadge: types.optional(types.boolean, false),
    prospectingActiveTab: types.optional(types.string, PROSPECTING_TABS.company),
    searchActiveTab: types.optional(types.string, SEARCH_TABS.contacts),
    uniqueSearchId: types.optional(types.string, ''),
    previousJob: types.optional(PreviousJobDataModel, () => PreviousJobDataModel.create()),
    selectedDataPointType: types.maybeNull(types.optional(types.string, BUTTON_TYPES.EMAIL_AND_PHONE)),
    creditSplitClickedButtonType: types.maybeNull(types.optional(types.string, 'show')),
    creditSplitClickedButtonId: types.maybeNull(types.optional(types.string, '')),
    showCreditSplitPopup: types.optional(types.boolean, false),
    creditSplitErrorType: types.optional(types.string, ''),
    searchQuery: types.optional(types.union(types.null, SearchQueryModel), null), // Union type to allow null or SearchDataModel
    shouldResearchEmployees: types.optional(types.boolean, false),
};
const Search = types.model(ModelProps).actions(Actions).views(Views);
export default Search;
